export default {
    filters: {},
    analitycSeries: null,
    isLoadReport: false,
    dates: {},
    generalData: {}
  }